import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    sysAdmin: false,
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setSysAdmin: (state, action) => {
            state.sysAdmin = Boolean(action.payload);
        },
    }
});

export const { setSysAdmin } = userSlice.actions;
export default userSlice.reducer;